/* Exact species membership for previews and results; never changes stock. */
(() => {
  const speciesQuery = id => `tag:"dex:${Number(id)}" OR (tag:"dex:all" AND NOT tag:"dex-not:${Number(id)}")`;
  const matchesSpecies = (p,s) => p.tags.includes('dex:'+s.id) || (p.tags.includes('dex:all') && !p.tags.includes('dex-not:'+s.id));
  const isBundle = p => /bundle/i.test(p.productType) || p.tags.includes('Core BUN') || p.tags.includes('core:bundles');
  const isSpeciesCollection = p => isBundle(p) && (/species collection|popular character collection/i.test(p.title) || p.tags.includes('core:character-collections'));
  async function loadSpecies(items, country, signal) {
    if (!items.length || items.length>6 || items.some(s=>!Number.isInteger(s.id)||s.id<1||s.id>1025)) throw Error('Invalid species');
    const products=Object.fromEntries(items.map(s=>[s.id,[]]));
    let pending=items.map((s,i)=>({species:s,alias:'p'+i,after:null}));
    const market=/^[A-Z]{2}$/.test(country)?country:'CA';
    while(pending.length) {
      const fields=pending.map(q=>`${q.alias}:products(first:50,query:${JSON.stringify(speciesQuery(q.species.id))}${q.after?',after:'+JSON.stringify(q.after):''}){
        pageInfo{hasNextPage endCursor} nodes{id handle title vendor productType tags availableForSale
        priceRange{minVariantPrice{amount currencyCode} maxVariantPrice{amount currencyCode}}
        featuredImage{url(transform:{maxWidth:600})}}}`).join('\n');
      const response=await fetch('/api/2026-07/graphql.json',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({query:`query @inContext(country:${market}) {${fields}}`}),signal});
      if(!response.ok)throw Error('Catalog unavailable');
      const result=await response.json();if(result.errors||!result.data)throw Error('Catalog unavailable');
      pending=pending.filter(q=>{
        const connection=result.data[q.alias];if(!connection)throw Error('Catalog unavailable');
        products[q.species.id].push(...connection.nodes.filter(p=>matchesSpecies(p,q.species)));
        if(connection.pageInfo.hasNextPage) {
          const cursor=connection.pageInfo.endCursor;if(!cursor||cursor===q.after)throw Error('Catalog unavailable');
          q.after=cursor;return true;
        }
        return false;
      });
    }
    for(const id of Object.keys(products))products[id]=[...new Map(products[id].map(p=>[p.id,p])).values()];
    return products;
  }
  window.KillinPokedex={speciesQuery,matchesSpecies,isBundle,isSpeciesCollection,loadSpecies};
})();
